import axios from "@/api/axios";

const createDeal = (data) => {
    return axios
        .post('/admin/deals/create-deal', {deals: data})
        .then(response => response.data)
}

const updateStage = (data) => {
    return axios
        .post('/admin/deals/update-stage', {deals: data})
        .then(response => response.data)
}

const updateSuccess = (data) => {
    return axios
        .post('/admin/deals/update-success', {deals: data})
        .then(response => response.data)
}

const updateFailure = (data) => {
    return axios
        .post('/admin/deals/update-failure', {deals: data})
        .then(response => response.data)
}

const failureTypes = (data) => {
    return axios
        .post('/admin/deals/failure-types', {deals: data})
        .then(response => response.data)
}

export default {
    createDeal,
    updateStage,
    updateSuccess,
    updateFailure,
    failureTypes
}